// removed by extract-text-webpack-plugin
module.exports = {"navbarText":"lT6Rt","navbarWrapper":"_34Tyq","linkText":"t1P_K","linkWrapper":"_3jKf0","searchIcon":"_4ZBsE","logoWrapper":"_2mC_p"};


//////////////////
// WEBPACK FOOTER
// ./src/views/components/Navbar/NavbarDesktop.less
// module id = 633
// module chunks = 0